import { createAction } from '@reduxjs/toolkit';

export const userLogout = createAction('user/logout');